'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.backgroundFor = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n\n  ', ';\n\n  /*\n    This linear gradient hack makes it possible to\n    use an overlay together with the background image.\n  */\n  ', ';\n'], ['\n  width: 100%;\n  height: 100%;\n\n  ', ';\n\n  /*\n    This linear gradient hack makes it possible to\n    use an overlay together with the background image.\n  */\n  ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var backgroundFor = exports.backgroundFor = function backgroundFor(props) {
  var background = props.background,
      fade = props.fade;

  var ownProps = { background: background, fade: fade };

  if (!background) {
    return null;
  }

  // React element passed, simply return it
  // This allows to specify custom background components.
  if (_react2.default.isValidElement(background)) {
    return background;
  }

  if (typeof background === 'string') {
    // It's an image url
    var imgRx = /\.(jpe?g|gif|png|bmp|svg)$/i;

    if (background.match(imgRx)) {
      return _react2.default.createElement(PlainBackground, _extends({}, ownProps, { image: background }));
    } else {
      // Interpret background as a value for
      // `background` css property.
      return _react2.default.createElement(PlainBackground, _extends({}, ownProps, { raw: background }));
    }
  }

  var invalidTypeWarn = 'Invalid `background` prop passed. It can be either a ' + 'string (e.g. `blue` or `http://foo.io/image.jpg`) or ' + 'a valid React element.';

  console.warn(invalidTypeWarn);
  return null;
};

var PlainBackground = _styledComponents2.default.div(_templateObject, function (props) {
  return props.raw && 'background: ' + props.raw;
}, function (props) {
  return props.image && 'background: linear-gradient(\n      rgba(0, 0, 0, ' + (props.fade || 0.0) + '),\n      rgba(0, 0, 0, ' + (props.fade || 0.0) + ')\n    ), url(' + props.image + ') center center / cover no-repeat';
});